import styled from "styled-components";
import { theme } from "../../styles/appTheme";

export const CompleteTitleText = styled.h1({
  margin: "40px 0 0",
  fontSize: 18,
  fontWeight: 700,
  textAlign: "center",
});

export const MessageText = styled.p({
  margin: "24px 0 0",
  color: theme.palette.text,
  fontSize: 16,
  fontWeight: 400,
  lineHeight: 1.8,
});

export const OutlineButton = styled.button({
  border: 1,
  borderRadius: 8,
  padding: 16,
  fontSize: 14,
  fontWeight: 700,
  lineHeight: 1.5,
  cursor: "pointer",
  width: "100%",
  marginTop: 24,
  borderStyle: "solid",
  borderColor: theme.palette.divider,
  background: theme.palette.white,
  color: theme.palette.text,
});
